module.exports = __webpack_public_path__ + "img/制御工学7_3.501757c8.png";